import React from "react";

function Download(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 16 24"
      className={props.className}>
      <g id="Group_11789" data-name="Group 11789" transform="translate(-628 -904)">
        <g id="Group_11788" data-name="Group 11788" transform="translate(628 908)">
          <path id="Rectangle_382" data-name="Rectangle 382" d="M1,1V19H19V1H1M0,0H20V20H0Z" transform="translate(0 0)" fill="#333" />
        </g>
        <path id="Path_11811" data-name="Path 11811" d="M-6663-2035h-2v-5h-5v-2h7Z" transform="translate(-5517.365 4191.94) rotate(135)" fill="#333" />
      </g>
    </svg>
  );
}

export default Download;